class VuelidateHelper {
  constructor(v) {
    this.v = v
  }

  getErrors(fieldName, label = '') {
    let errors = []
    let field = {}
    let descripcion =
      label || fieldName[0].toUpperCase() + fieldName.slice(1).toLowerCase()

    if (fieldName.includes('.')) {
      let i,
        aux = {}

      let campos = fieldName.split('.')
      aux = this.v[campos[0]]

      for (i = 1; i < campos.length; i++) {
        aux = aux[campos[i]]
        descripcion =
          label || campos[i][0].toUpperCase() + campos[i].slice(1).toLowerCase()
      }

      field = aux
    } else {
      field = this.v[fieldName]
    }

    if (!field.$dirty) return errors

    if (field.required !== undefined && !field.required) {
      let descRequired = 'es requerido'
      const tokens = descripcion.split(' ')

      if(tokens.length > 1){
        const articulo = tokens[0].toLowerCase()
        
        if(articulo === 'la')
        {
          descRequired = 'es requerida'
        }

        if(articulo === 'las'){
          descRequired = 'son requeridas'
        }

        if(articulo === 'los'){
          descRequired = 'son requeridos'
        }
      }

      errors.push(`${descripcion} ${descRequired}.`)
    }

    if (field.minLength !== undefined && !field.minLength) {
      errors.push(
        `${descripcion} debe tener una longitud mínima de ${field.$params.minLength.min} caracteres.`
      )
    }

    if (field.maxLength !== undefined && !field.maxLength) {
      errors.push(
        `${descripcion} debe tener una longitud máxima de ${field.$params.maxLength.max} caracteres.`
      )
    }

    if (field.email !== undefined && !field.email) {
      errors.push(`${descripcion} debe ser válido.`)
    }

    if (field.sameAsPassword !== undefined && !field.sameAsPassword) {
      errors.push('Las contraseñas deben coincidir.')
    }

    if (field.strongPassword !== undefined && !field.strongPassword) {
      errors.push(
        'Contraseña débil. Debe contener al menos 8 caracteres de longitud, una mayúscula, una minúscula, un número y un carácter especial.'
      )
    }

    if (field.rfcValidation !== undefined && !field.rfcValidation) {
      errors.push('El RFC no es válido.')
    }

    if (field.rfcNotOwner !== undefined && !field.rfcNotOwner) {
      errors.push('No se puede usar el RFC del propietario.')
    }

    if (field.rfcDuplicate !== undefined && !field.rfcDuplicate) {
      errors.push('Ya existe este RFC.')
    }

    if (field.notSpecialChars !== undefined && !field.notSpecialChars) {
      errors.push(
        'El texto no debe contener caracteres especiales (#¿?¡!$%^~+*/\\<>=¨´[]{}`¬°).'
      )
    }

    if (field.notSpecialCharsPunctuation !== undefined && !field.notSpecialCharsPunctuation) {
      errors.push(
        'El texto no debe contener caracteres especiales (#¿?¡!$%^~+*/\\<>=¨´[]{}`¬°-@:;,).'
      )
    }

    if (field.notSpecialCharsDescription !== undefined && !field.notSpecialCharsDescription) {
      errors.push(
        'El texto no debe contener caracteres especiales (¿?¡!^~<>¨´[]{}`¬°).'
      )
    }

    if (field.emailValidation !== undefined && !field.emailValidation) {
      errors.push(
        'El email no es válido o contiene alguno de estos caracteres inválidos (#¿?¡!$%^~+*/\\<>=¨´[]{}`¬°|:;,).'
      )
    }

    if (field.emailNotOwner !== undefined && !field.emailNotOwner) {
      errors.push('No se puede usar el correo del propietario.')
    }

    if (field.emailDuplicate !== undefined && !field.emailDuplicate) {
      errors.push('Ya existe este email.')
    }

    return errors
  }
}

export default VuelidateHelper
